import PropTypes from 'prop-types'
import { Box, Button, Chip } from '@material-ui/core'
import PerfectScrollbar from 'react-perfect-scrollbar'
import clsx from 'clsx'

import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from 'components/Table'
import { MenuButton, Permitted } from 'components'

import helpers from 'helpers'

import constants from 'constants/index'
import useStyles from './styles'

const RegulationVersionsTable = ({
  regulationVersions = [],
  isLoading = false,
  type = constants.regulations.FORM_TYPES.EDIT,
  onShow = () => {},
  onInactive = () => {},
}) => {
  const { STATUSES, STATUS_LABEL } = constants.regulations
  const { REGULATIONS } = constants.permissions

  const classes = useStyles()

  const isShow = type === constants.regulations.FORM_TYPES.SHOW

  const STATUS_CLASS = {
    [STATUSES.ACTIVE]: classes.active,
    [STATUSES.INACTIVE]: classes.inactive,
  }

  return (
    <Box width="100%">
      <PerfectScrollbar
        options={{ wheelPropagation: false, useBothWheelAxes: true }}
      >
        <Table
          emptyMessage="Nenhuma versão encontrada"
          isLoading={isLoading}
          noWrap
        >
          <TableHead>
            <TableRow>
              <TableCell width="10%">Versão</TableCell>
              <TableCell width="25%" align="left">
                Autor
              </TableCell>
              <TableCell width="15%" align="left">
                Status
              </TableCell>
              <TableCell width="20%" align="left">
                Início
              </TableCell>
              <TableCell width="20%" align="left">
                Prazo
              </TableCell>
              <TableCell width="10%" align="right">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {regulationVersions?.map((regulationVersion) => {
              const isInactive = regulationVersion?.status === STATUSES.INACTIVE

              return (
                <TableRow key={regulationVersion?.id} hover>
                  <TableCell>{regulationVersion?.version}</TableCell>
                  <TableCell>
                    {regulationVersion?.author?.name || '-'}
                  </TableCell>
                  <TableCell disableTooltip>
                    <Chip
                      className={clsx(
                        classes.chip,
                        STATUS_CLASS[regulationVersion?.status],
                      )}
                      size="small"
                      label={
                        STATUS_LABEL[regulationVersion?.status] || 'Indefinido'
                      }
                    />
                  </TableCell>
                  <TableCell>
                    {helpers.formatters.dates.ptBrFormatDate(
                      regulationVersion?.startsAt,
                    )}
                  </TableCell>
                  <TableCell>
                    {helpers.formatters.dates.ptBrFormatDate(
                      regulationVersion?.endsAt,
                    )}
                  </TableCell>
                  <TableCell disableTooltip align="right">
                    <MenuButton>
                      <Button
                        fullWidth
                        size="small"
                        onClick={() => onShow(regulationVersion?.id)}
                      >
                        Visualizar
                      </Button>
                      {!isShow && !isInactive && (
                        <Permitted tag={REGULATIONS.MANAGE}>
                          <Button
                            fullWidth
                            size="small"
                            onClick={() => onInactive(regulationVersion?.id)}
                          >
                            Inativar
                          </Button>
                        </Permitted>
                      )}
                    </MenuButton>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </PerfectScrollbar>
    </Box>
  )
}

RegulationVersionsTable.propTypes = {
  regulationVersions: PropTypes.arrayOf(PropTypes.object),
  isLoading: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(constants.regulations.FORM_TYPES)),
  onShow: PropTypes.func,
  onInactive: PropTypes.func,
}

export default RegulationVersionsTable
